import { COLOR_PRIMARY } from "common/utils/theme"
import { Button } from "primereact/button"
import { OverlayPanel } from "primereact/overlaypanel"
import React, { useContext, useMemo, useRef } from "react"
import { useTranslation } from "react-i18next"
import DocumentosEstadoMessage from "../components/DocumentosEstadoMessage/DocumentosEstadoMessage"
import { ESTADO_COLUMN } from "../constants"

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
const DocumentoColumnsContext = React.createContext()

const DocumentoColumnsProvider = ({ children, columns }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const refPanelEstado = useRef()

  const newColumns = useMemo(() => {
    return columns.map((column: $TSMigrationFixMe) => {
      if (column.key === ESTADO_COLUMN) {
        return {
          ...column,
          header: (
            <span className='d-flex align-items-center'>
              {t("crear.presupuesto.tab.headerState")}{" "}
              <Button
                // @ts-expect-error TS(2339): Property 'toggle' does not exist on type 'never'.
                onClick={(e) => refPanelEstado.current?.toggle(e)}
                className='p-0 ml-1 p-button-text'
                icon='pi pi-info-circle'
                style={{
                  color: COLOR_PRIMARY,
                }}
              />
            </span>
          ),
        }
      }

      return column
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns])

  const value = {
    columns: newColumns,
  }

  return (
    <DocumentoColumnsContext.Provider value={value}>
      {children}
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <OverlayPanel ref={refPanelEstado}>
        <DocumentosEstadoMessage />
      </OverlayPanel>
    </DocumentoColumnsContext.Provider>
  )
}

export const useDocumentoColumns = () => useContext(DocumentoColumnsContext)

export default DocumentoColumnsProvider
